import { Chart as ChartJS } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import LoadingSquare from "shared/components/loading/LoadingSquare";
import React from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(ChartDataLabels);

/*interface GoalDifferenceData {
  overallDifference: number;
  goalDifference: number;
  rate: number;
  engine: string;
}

interface ChartBarGoalDifferenceProps {
  data?: GoalDifferenceData[];
  reverse?: boolean;
}*/

const ChartBarGoalDifference /*: React.FC<ChartBarGoalDifferenceProps>*/ = ({ data, reverse }) => {
  if (!data) return <LoadingSquare />;

  const buckets = {
    "+3": data.filter((d) => d.goalDifference >= 3).reduce((sum, d) => sum + d.rate, 0),
    "+2": data.filter((d) => d.goalDifference === 2).reduce((sum, d) => sum + d.rate, 0),
    "+1": data.filter((d) => d.goalDifference === 1).reduce((sum, d) => sum + d.rate, 0),
    0: data.filter((d) => d.goalDifference === 0).reduce((sum, d) => sum + d.rate, 0),
    "-1": data.filter((d) => d.goalDifference === -1).reduce((sum, d) => sum + d.rate, 0),
    "-2": data.filter((d) => d.goalDifference === -2).reduce((sum, d) => sum + d.rate, 0),
    "-3": data.filter((d) => d.goalDifference <= -3).reduce((sum, d) => sum + d.rate, 0),
  };

  // Total Winner / Draw / Loss rates
  const winnerRate = buckets["+3"] + buckets["+2"] + buckets["+1"];
  const drawRate = buckets[0];
  const lossRate = buckets["-1"] + buckets["-2"] + buckets["-3"];
  const selectedTeamWinRate = reverse ? lossRate : winnerRate;
  const selectedTeamLossRate = reverse ? winnerRate : lossRate;

  const labels = ["+3", "+2", "+1", "0", "-1", "-2", "-3"];
  const colors = [
    "rgba(248, 98, 133, 1)",
    "rgba(248, 98, 133, .95)",
    "rgba(248, 98, 133, .9)",
    "rgba(248, 98, 133, 0.55)",
    "rgba(108, 117, 125, .7)",
    "rgba(108, 117, 125, .6)",
    "rgba(108, 117, 125, .5)",
  ];
  const chartLabels = reverse ? [...labels].reverse() : labels;
  const rates = labels.map((label) => buckets[label]);
  const chartRates = reverse ? [...rates].reverse() : rates;
  const chartColors = reverse ? [...colors].reverse() : colors;

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Goal Difference Rate",
        data: chartRates,
        backgroundColor: chartColors,
        borderWidth: 0,
        categoryPercentage: 1,
        barPercentage: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "end",
        color: "rgb(173, 181, 189)",
        font: {
          weight: "normal",
          size: 12,
        },
        formatter: (val) => (val > 0 ? val.toFixed(1) + "%" : ""),
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    layout: {
      padding: { top: 20 },
    },
  };

  return (
    <div className="h-100 w-100">
      {/* Summary */}
      <div className="d-flex justify-content-center gap-4 mt-2">
        <span className="text-center">
          <strong className="d-block text-main">Win</strong>
          <span>{selectedTeamWinRate.toFixed(1)}%</span>
        </span>

        <span className="text-center">
          <strong className="d-block" style={{ color: "rgba(248, 98, 133, 0.55)" }}>
            Draw
          </strong>
          <span>{drawRate.toFixed(1)}%</span>
        </span>

        <span className="text-center">
          <strong className="d-block text-secondary">Loss</strong>
          <span>{selectedTeamLossRate.toFixed(1)}%</span>
        </span>
      </div>

      <div style={{ height: "calc(100% - 55px)" }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ChartBarGoalDifference;
